import React from 'react'
import { useSelector } from 'react-redux'
import { money } from '../../utils/helpers'

const CartBottom = (data) => {
  const { cart, hasGift } = useSelector((state) => state.cart)
  const makePermalink = () => {
    return cart.items.map((item) => `${item.variant_id}:${item.quantity}`).join(',')
  }

  return (
    <div className='pr-3 lg:pr-10'>
      <div className='pt-4 lg:pt-6 border-t before:border-[rgba(33,33,33,0.25)]'>
        <div className='flex justify-between text-second text-sm leading-4 mb-4 lg:mb-6'>
          <strong>Subtotal</strong>
          <strong className='text-second text-sm leading-4'>{money(cart.items_subtotal_price)}</strong>
        </div>
        <a className='button w-full !bg-black !text-white !border-black hover:!bg-white hover:!border-black hover:!text-black  focus:!bg-white focus:!border-black focus:!text-black !py-2 lg:!py-3' 
          href={hasGift && !location.href.includes('/cart') ? '/cart' : '/checkout'}
          onClick={e => {
            if(!(hasGift && !location.href.includes('/cart'))) {
              window.dataLayer = window.dataLayer || []
              dataLayer.push({'event': 'checkout_click'})
            }
          }}
        >
          Checkout
        </a>
        <a className='button button--secondary !border-black w-full mt-3.5 !py-2 lg:!py-3 focus:outline hover:!bg-transparent' href={`/cart/${makePermalink()}?payment=shop_pay`}>
          <img className='h-5' src={window.globalIcons['icon-shop-pay']} alt='ShopPay' />
        </a>
        <div className='text-center mt-3 lg:mt-6'>
          <a className='focus-link' href='/cart'>View Shopping Cart</a>
        </div>
      </div>
    </div>
  )
}

export default CartBottom